import React from "react";
import { Typography, IconButton, Theme, ButtonBase } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme: Theme) => ({
	submit: {
		margin: theme.spacing(1, 0, 3),
		textDecoration: "none",
	},
}));
const path = window.location.pathname.split("/")[1];
export function BackToSignInButton() {
	const classes = useStyles();
	return (
		<Link to={`/${path}/signin`} className={classes.submit}>
			<div style={{ display: "flex", margin: 10 }}>
				<ChevronLeftIcon color="secondary" />
				<Typography color="secondary" variant="button">
					BACK TO SIGN IN
				</Typography>
			</div>
		</Link>
	);
}
export function ForgotUsernameButton() {
	const classes = useStyles();
	return (
		<Link to={`/${path}/forgot/username`} className={classes.submit}>
			<div style={{ display: "flex", margin: 10 }}>
				<Typography color="secondary" variant="button">
					Forgot Username
				</Typography>
			</div>
		</Link>
	);
}

export function ForgotPasswordButton() {
	const classes = useStyles();
	return (
		<Link to={`/${path}/forgot/password`} className={classes.submit}>
			<div style={{ display: "flex", margin: 10 }}>
				<Typography color="secondary" variant="button">
					FORGOT PASSWORD
				</Typography>
			</div>
		</Link>
	);
}

export function CloseButton(props: any) {
	return (
		<ButtonBase centerRipple={true} focusRipple={true}>
			<IconButton onClick={props.onClose} size="large">
				{props.style === "open" ? (
					<CloseIcon
						sx={{
							color: props.color || "white",
						}}
					/>
				) : (
					<HighlightOffIcon sx={{ color: props.color || "white" }} />
				)}
			</IconButton>
		</ButtonBase>
	);
}
